export const stringToArray = (string) => {
    return string.slice(1,-1).split(", ").map((element)=>element.slice(1,-1))
}